"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryListRequest = void 0;
var HistoryListRequest = /** @class */ (function () {
    function HistoryListRequest() {
    }
    return HistoryListRequest;
}());
exports.HistoryListRequest = HistoryListRequest;
;
//# sourceMappingURL=historyList.request.js.map